import { useEffect } from 'react'
import { X, CheckCircle, AlertCircle, Info } from 'lucide-react'
import { useUIStore } from '../stores/uiStore'

export default function Toast() {
  const { toast, clearToast } = useUIStore()

  useEffect(() => {
    if (!toast) return
    const timer = setTimeout(() => clearToast(), 4000)
    return () => clearTimeout(timer)
  }, [toast, clearToast])

  if (!toast) return null

  const icon =
    toast.type === 'success' ? <CheckCircle size={18} className="text-green-600" /> :
    toast.type === 'error' ? <AlertCircle size={18} className="text-red-600" /> :
    <Info size={18} className="text-blue-600" />

  const bgClass =
    toast.type === 'success' ? 'bg-green-50 border-green-200 text-green-800' :
    toast.type === 'error' ? 'bg-red-50 border-red-200 text-red-800' :
    'bg-blue-50 border-blue-200 text-blue-800'

  return (
    <div className="fixed bottom-6 right-6 z-50 animate-[slideIn_0.2s_ease-out]">
      <div className={`flex items-center gap-3 px-4 py-3 rounded-lg border shadow-lg ${bgClass}`}>
        {icon}
        <span className="text-sm font-medium">{toast.message}</span>
        <button onClick={clearToast} className="p-0.5 hover:opacity-70" aria-label="Dismiss">
          <X size={14} />
        </button>
      </div>
    </div>
  )
}
